export default class DisponibilidadService{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/disponibilidad_equipo',
            "id": '/api/disponibilidad_equipo/:id',
            "new": '/api/disponibilidad_equipo',
            'delete': '/api/disponibilidad_equipo/:id',
            "update": '/api/disponibilidad_equipo',
		};
	}

    getAll(filter){
        let url = this.baseUrl + this.routes.all;
        let config = {
            params : filter
        };
        return this.http.get(url, config);
    }

    getById(objId){
        let idRoute = this.routes.id.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.get(url);
    }

    save(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.post(url, data);
    }

    update(data){
        let url = this.baseUrl + this.routes.new;
        if(data.flag_turno === "true") {
            data.flag_turno = true;
            data.flag_no_disponible = false;
        } else {
            data.flag_turno = false;
            data.flag_no_disponible = true;
        }
        return this.http.put(url, data);
    }

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/disponibilidad.js